import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { maintenanceGuard } from './shared/guards/maintenance/maintenance.guard';
import { domainGuard } from './shared/guards/domain/domain.guard';
import { MaintenanceComponent } from './shared/components/maintenance/maintenance.component';
import { ErrorComponent } from './shared/components/error/error.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';

export const routes: Routes = [
  {
    path: 'error', canActivate: [maintenanceGuard, domainGuard], component: ErrorComponent, title: 'Something went wrong' 
  },
  {
    path: 'maintenance', canActivate: [domainGuard], component: MaintenanceComponent, title: 'Maintenance' 
  },
  {
    path: 'home', title: 'Password Reset', canActivate: [maintenanceGuard, domainGuard], component: HomeComponent
  },
  {
    path: 'woolworths-password-reset',
    canActivate: [maintenanceGuard, domainGuard],
    loadChildren: () => import('./woolworths-password-reset/woolworths-password-reset.module').then((m) => m.WoolworthsPasswordResetModule)
  },
  {
    path: 'endeavour-drinks-password-reset',
    canActivate: [maintenanceGuard, domainGuard],
    loadChildren: () => import('./edg-password-reset/edg-password-reset.module').then((m) => m.EdgPasswordResetModule)
  },
  {
    path: 'new-user',
    canActivate: [maintenanceGuard, domainGuard],
    loadChildren: () => import('./new-user-registration/new-user-registration.module').then((m) => m.NewUserRegistrationModule)
  },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  {
    path: '**', canActivate: [maintenanceGuard, domainGuard], component: NotFoundComponent, title: '404 Not Found' 
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    paramsInheritanceStrategy: 'always',
  })],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
